import React from 'react';
import { Col, Row } from 'react-bootstrap';
import CatalogoProductos from './CatalogoProductos';
import Greetings from './Greeting/Greetings';

const Productos = () => {
    return (
        <>
            <Row>
                <Col className="col-12">
                    <Greetings />
                </Col>
               
            </Row>
            <Row>
                <Col className="col-12">
                    <CatalogoProductos />
                </Col>
            </Row>

        </>
    );
};

export default Productos;